export default __webpack_public_path__ + "static/media/marvel.568d8c62.png";